/*
 * @Description: Description
 * @Author: dpw
 * @Date: 2023-12-09 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:36:47
 */
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Анализ отчёта ИИ",
        train: "План обучения",
        loading: "Загрузка...",
        loadingError1: "Ошибка загрузки",
        loadingError2: "Извините. Попробуйте позже.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Регистрация / Вход',
        registerAndLogin: 'Регистрация / Вход',
        userLogin: 'Войти',
        title: 'Аккаунт, регистрируемый по номеру телефона и электронному  почтовому адресу, являются независимыми друг от друга',
        mobileLogin: 'Тел.',
        emailLogin: 'Эл.почта',
        email: 'E-mail',
        loginBtn: 'Войти',
        autoLogin: 'Запомнить меня',
        retransmission: '{item}с',
        formList: [
            {
                label: 'Введите свой телефонный номер',
                placeholder: 'Отправить',
            },
            {
                label: 'авторизация',
                placeholder: 'Введите код',
            },
            {
                label: 'Введите email',
            },
        ],
        btn: {
            submit: 'Создать аккаунт',
            title: 'В целях  получения более верных данных, важно указать точные вес, пол и возраст',
        },
        rule: {
            phone: {
                requiredMsg: 'Неверный  формат номера телефона',
                patternMsg: 'Номер  телефона  не зарегистрирован, создайте  аккаунт',
            },
            authCode: {
                requiredMsg: 'Неверный  код авторизации, пожалуйста, введите код заново',
            },
            email: {
                requiredMsg: 'Неверный формат электронной почты',
                patternMsg: 'Электронная почта не зарегистрирована, создайте аккаунт',
            },
        },
        codeSuccess: 'Код подтверждения был отправлен, пожалуйста, проверьте.',
        success: 'Успешно отправлено',
        error: 'Ошибка отправки',
        loginSuccess: 'Успешная авторизация',
        account: {
            accountTitle: 'Войти',
            registerTitle: 'Регистрация',
            resetTitle: 'Установить пароль',
            password: 'Пароль',
            placeholder: 'Пожалуйста, введите пароль',
            codeLogin: 'Вход с помощью проверочного кода',
            accountLogin: 'Вход с помощью пароля',
            forgotPassword: 'Забыли пароль?',
            registerTips:[
                'Ещё нет аккаунта?', 
                'Регистрация', 
                'Аккаунт уже существует',
                'Регистрация',
            ],
            checkRule: [
                'От 8 до 20 символов',
                'Должен содержать хотя бы одну заглавную букву',
                'Должен содержать хотя бы одну строчную букву',
                'Должен содержать хотя бы одну цифру', 
                'Пароли не совпадают'
            ],
            errorTips: [
                'Неверный пароль', 
                'Не удалось войти', 
                'Аккаунт не существует'
            ],
            reset:[
                'Сбросить пароль', 
                "Далее",
                'Новый пароль не может совпадать с предыдущим', 
                'Пропустить',
                'Пароль успешно установлен'
            ],
            setPasswordTips:'Пароль должен состоять из 8–20 символов и содержать заглавные буквы, строчные буквы и цифры.',
            confirmPassword: "Подтвердите пароль",
        },
        switchButton: 'Вход по паролю',
        switchButton1: 'Вход с помощью проверочного кода',
        loginTips: 'Незарегистрированные учетные записи будут автоматически зарегистрированы после успешного входа.',
        otherLogin: 'Другие способы входа',
        newEmailLogin: 'Вход по электронной почте',
        newPhoneLogin: 'Вход по номеру телефона',
        bindLineTips:'Или',
        bindEmail: 'Вход через привязанную почту',
        bindPhone: 'Вход через привязанный номер телефона',
        bindAndContinue: "Привязать и продолжить",
        bind: "Привязать",
        bindEmailTitle: 'Привязать почту',
        bindEmailTips1: "Данные почты {item} не найдены",
        bindEmailTips2: "Привяжите почту для продолжения",
        bindEmailTips3: "Ваш аккаунт ещё не привязан к email. После привязки вы сможете входить по email и сбрасывать пароль.",
        boundTitle: 'Вы уже регистрировались?',
        boundCenterTitle1:'Если вы новый пользователь',
        boundCenterTips1:'Создайте аккаунт, чтобы начать',
        boundCenterTitle2:'Если у вас уже есть аккаунт',
        boundCenterTips2:'Привяжите для синхронизации данных',
        boundCenterTips3:'Привяжите зарегистрированную учетную запись',
        boundCenterTips4:'Рекомендуем',
        boundCenterTips5:'Привязать {item} к аккаунту',
        boundCenterTips6:'Данные и отчеты синхронизируются',
        boundButton1: 'Создать аккаунт через {item}',
        boundButton2: 'Привязать существующий аккаунт',
        phoneCode:"Вход по коду из SMS",
        phonePassword:"Вход по номеру телефона и паролю",
        emailCode:"Вход по коду из email",
        emailPassword:"Вход по email и паролю",
        accountDoesNotExist:"Этот аккаунт еще не зарегистрирован. Пожалуйста, завершите регистрацию с помощью кода из письма или через {item}.",
        toRegister:"Регистрация",
        bindNow: "Привязать сейчас",
        bindError:[
            'Ошибка привязки',
            'Отвязка прошла успешно',
            'Ошибка отвязки',
            'Ошибка авторизации',
            'Ошибка авторизации, не удалось получить данные аккаунта',
            'Привязка выполнена успешно',
            'Учетная запись не существует. Пожалуйста, привяжите зарегистрированную учетную запись.',
            'Не удалось выполнить привязку. Эта учетная запись уже привязана к учетной записи {item} [{nickname}].',
            'Авторизовано и зарегистрировано как учетная запись, отвязка не поддерживается',
            'Учетная запись не существует, используйте код подтверждения для входа и регистрации',
        ],
        accountSecurity: {
            faceBook:'Учетная запись Facebook',
            google: 'Учетная запись Google',
            isBind: 'Не привязано',
            dialogTitle: 'Подтвердить отвязку?',
            dialogCenter: 'После отвязки {item} вы больше не сможете использовать его для входа в эту учетную запись.',
            bindFailure:'Ошибка привязки',
            bindFailureTips: 'Ваша учетная запись {item} уже привязана к учетной записи ниже. Если вы хотите переключить привязку на текущую учетную запись, пожалуйста, войдите в учетную запись ниже, чтобы сначала отвязать ее.',
            returnButton:'Подтвердить и вернуться'
        },
        bindEmailError: [
            "Почта занята. Используйте другую."
        ],
    },
    // 注册页面
    register: {
        mobileRegister: 'Тел.',
        emailRegister: 'Эл.почта',
        enroll: 'Данный номер уже зарегистрирован',
        enrollEmail: 'Электронная  почта зарегистрирована',
        search: 'Поиск',
        title: 'Аккаунт, регистрируемый по номеру телефона и электронному  почтовому адресу, являются независимыми друг от друга',
        needRead: {
            agree: 'Я ознакомился и согласен',
            privacy: 'Политика конфиденциальности',
        },
        register: 'Регистрация',
        check: 'Ознакомлен с  “Политикой конфиденциальности”',
        newUser: 'Регистрация нового пользователя',
        form: {
            labelList: ['Имя', '* Пол', '* Рост', '* Возраст'],
        },
        placeholder: ['Пожалуйста, введите имя', 'Введите рост', 'Пожалуйста, введите возраст'],
        unit: ['Метрическая', 'Имперская', ''],
        sexOptions: {
            male: 'МУЖ',
            female: 'ЖЕН',
        },
        btn: 'Отправить',
        rules: {
            metricheight: ["Диапазон роста составляет от 2'3'' до 6'7'', пожалуйста, введите  заново."],
            heightMsg: ['Диапазон роста составляет от 70 до 200 см, пожалуйста, введите  заново.'],
            ageMsg: ['Возрастной диапазон составляет от 10 до 99 лет, пожалуйста,  введите заново.'],
            agePointMsg: [
                'Введено нецелое число: возраст может быть только целым числом,  пожалуйста, введите правильный возраст.',
            ],
        },
        success: 'Успешная регистрация',
        userMessage: 'Введите имя пользователя',
        verify: 'Введите 4х значный код верификации',
        errorMsg: 'Формат данных роста не поддерживает знаки после запятой,  пожалуйста введите заного',
        abnormalMsg: 'Аномалия регистрации',
    },
    // 模型合成
    model: {
        loading: 'Загрузка…Пожалуйста подождите',
        modelLoading: 'Загрузка 3D модели',
        tabPane: [
            {
                title: 'Технология Deep Real Sense',
                msg: 'Точно собирает локальные детали тела с помощью 3D-сканирования,  обеспечивает миллиметровую точность измерения окружности и четко представляет  изменения формы тела после тренировки.',
            },
            {
                title: 'Алгоритм BDA состава тела',
                msg: 'Visbody  использует самую передовую систему измерения состава тела - алгоритм BDA для  определения состава тела. Этот метод расчета, основанный на объеме тела,  более точно оценит  риски для здоровья,  вызванные ожирением.',
            },
            {
                title: 'Факторы, вызывающие ошибки',
                msg: 'Свободная одежда или некоторые украшения на теле могут вызвать  ошибки, пожалуйста, надевайте обтягивающую одежду или уменьшайте количество  одежды на вашем теле, если вы хотите получить самые точные данные.',
            },
            {
                title: 'Получите ваш отчет',
                msg: 'Рекомендуется  добавить URL веб-страницы в закладки для удобного просмотра отчета в будущем.  Вы также можете отправить этот отчет на свою электронную почту, чтобы  сохранить его позже.',
            },
        ],
        collect: ['Пожалуйста, добавьте эту страницу в закладки, Легко просматривать отчет в будущем.', ''],
        know: 'Ясно',
        reminder: [
            'Напоминаем',
            'Ваша 3D-модель аватара создана, проведите влево и вправо, чтобы  повернуть модель.',
            "Ваш отчет был создан и его можно просмотреть, нажав кнопку  'Просмотреть отчет'.",
            'Оценка вашего тела не удалась, пожалуйста, просмотрите отчет о  составе тела.',
            'Оценка состава вашего тела не удалась, пожалуйста, просмотрите  отчет об оценке осанки.',
            'Ваше измерение не удалось, пожалуйста, перейдите к устройству и  повторите тест.',
            'Измерение состава тела не удалось, пожалуйста, перейдите к  устройству и повторите тест.',
            'Оценка осанки не удалась, пожалуйста, перейдите к устройству и  повторите тест.',
        ],
        btn: {
            viewReport: 'Просмотреть отчет',
            bodyReport: 'Просмотреть  отчет о составе тела',
            postureReport: 'Просмотреть отчет об осанке тела',
            lastReport: 'Просмотреть последний отчет',
            loading: 'Загрузка',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Скачать отчет',
            send: 'Отправить отчет',
            report: 'Отчет',
        },
        reportSuccess: 'Отчёт успешно создан',
        tabPane: {
            labelList: ['Время измерения', 'Тип измерения', 'Состав тела', 'Осанка тела', 'Функция  плеча'],
        },
        sendEmail: 'Отправить на эл.почту:',
        requiredMsg: 'Введите адрес эл.почты',
        patternMsg: 'Введите правильный email',
        send: 'Отправить',
        download: 'Скачать отчет',
        sendReport: 'Отправить отчет',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Успешная смена пола',
            height: 'Успешная смена роста',
            age: 'Успешная смена возраста',
        },
        logOut: 'Выйти',
        personal: 'Личный кабинет',
        cut: 'Сменить единицы измерения/язык',
        changeSort: 'Переключение отчета о продукте',
        setPassword: 'Установить/изменить пароль',
        accountSecurity: 'Учетная запись и безопасность',
        describe: 'После  переключения модели продукта, будут отображаться все отчеты об измерениях для  этой модели.',
        describeBtn:
            'После  переключения модели продукта, вы будете перенаправлены к последнему отчету об  измерениях для этой модели.',
        descReport: 'Успешное переключение отчета о продукте',
        unit: ['Метрическая (кг,см)', 'Имперская (фут,дюйм,фунт)'],
        read: {
            reading: 'Прочитать',
            privacy: 'Политика конфиденциальности',
        },
        setting: 'Настройки',
        form: {
            labelList: ['Тел.', 'Единица', 'Языки', 'Имя', 'Пол', 'Рост', 'Возраст'],
        },
        placeholder: ['Изменить имя пользователя', 'Изменить пол', 'Изменить рост', 'Изменить возраст'],
        btn: {
            cancelBtn: 'Отмена',
            accomplishBtn: 'Закончить',
            confirmBtn: 'Подвердить',
        },
        dialog: [
            'Пол является  одним из важных критериев для измерения состава тела. Данные, измеренные  после изменения, будут отличаться от предыдущих данных. Вы уверены, что  хотите его изменить?',
            'Рост  является одним из важных критериев для измерения состава тела. Данные,  измеренные после изменения, будут отличаться от предыдущих данных. Вы  уверены, что хотите его изменить?',
            'Возраст  является одним из важных критериев для измерения состава тела. Данные,  измеренные после изменения, будут отличаться от предыдущих данных. Вы  уверены, что хотите его изменить?',
        ],
        rules: {
            metricheight: [`Пожалуйста, заполните правильный диапазон роста (от 2'3" до  6'7")`],
            heightMsg: [`Пожалуйста, заполните рост в пределах 70 см - 200 см`],
            ageMsg: [`Пожалуйста, заполните возраст в пределах 10 - 99 лет.`],
        },
        heightMsg: 'Пожалуйста, выберите рост заново',
        ageMsg: 'Пожалуйста, выберите возраст заново',
        ModelBinding: 'Кажется,  кто-то уже отсканировал код, пожалуйста, пройдите тестирование снова!',
        ReportEmpty: {
            title: 'У вас еще нет ни одного отчета',
            desc: 'Приходите к 3D сканеру тела Visbody и пройдите тест снова!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Кажется,  кто-то уже отсканировал код, пожалуйста, пройдите тестирование снова!',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'У вас еще нет ни одного отчета',
        desc: 'Приходите к 3D сканеру тела Visbody и пройдите тест снова!',
        descS30: 'Приходите к 3D сканеру тела Visbody-S30 и пройдите тест снова!',
        descM30: 'Приходите к 3D сканеру тела Visbody-M30 и пройдите тест снова!',
    },
    // 用户信息
    userInfo: {
        height: 'Рост:',
        age: 'Возраст:',
        unit: '',
        weight: 'Вес',
    },
    // 体成分
    mass: {
        title: 'Обзор оценки состава тела',
        titles: 'Состав тела',
        springFrame: '',
        massFrame: 'Нет данных измерений за день',
        contrast: 'Выберите отчет для сравнения',
        contrastReport: 'Выберите отчет для сравнения',
        noRecord: 'Нет записей',
        score: 'Оценка',
        status: 'Ваш текущий статус состава тела',
        WT: 'Вес',
        PBF: 'Процент жира в организме',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Значения',
            standardRange: 'Стандартный диапазон',
            comparedWithLastLime: 'Сеть',
            comparedNet: 'В сравнении с  последней оценкой',
            current: '本次测量分数',
            WT: 'Вес',
            FFM: 'Сухая масса тела',
            BFM: 'Масса жира в теле',
            LM: 'Масса мышц',
            TBW: 'Вода в организме',
            SM: 'МСМ (Масса скелетных мышц)',
            PROTEIN: 'Белки',
            TM: 'Неорганические соли',
            BMR: 'Базальный метаболизм',
            WHR: 'WHR (Соотношение талии к бедрам)',
            BMI: 'ИМТ (Индекс массы тела)',
            PBF: 'Процент жира в теле',
            VFG: 'Уровень висцерального жира',
            unit: 'кг',
            BMRUnit: 'ккал/д',
        },
        // 定义解读
        explain: [
            {
                title: 'Вес',
                msg: 'Вес - это  сумма воды в организме, белка, неорганической соли и массы тела.',
            },
            {
                title: 'Сухая масса тела',
                msg: 'Сухая масса тела - это общий вес тела без жира',
            },
            {
                title: 'Масса жира в теле',
                msg: 'Масса жира в организме - это сумма подкожного жира,  висцерального жира и мышечного жира.',
            },
            {
                title: 'Масса мышц',
                msg: 'Мягкие нежировые ткани - сухая  масса тела, которая включает скелетные мышцы, гладкую мускулатуру и сердечные  мышцы.',
            },
            {
                title: 'Вода в организме',
                msg: 'Большая часть человеческого тела - это вода, составляющая  50%-70% от массы тела. И вода в организме в основном находится в клетках  человека и жидкостях организма, большая часть которой находится в мышечных  клетках.',
            },
            {
                title: 'МСМ (Масса скелетных мышц)',
                msg: 'Скелетно-мышечная  масса, также известная как поперечнополосатая мышца, это тип мышц,  прикрепленных к костям. Эти данные о количественном содержании скелетных  мышц.',
            },
            {
                title: 'Белок',
                msg: 'Белок - это сложные вещества, состоящие из аминокислот.  Являются неизменной составляющей частью рациона. Это главный строительный  материал, без которого невозможен рост мускулатуры и тканей в целом.',
            },
            {
                title: 'Неорганические соли',
                msg: 'Человеческое  тело состоит из органического, неорганического вещества и воды. Здесь  неорганическое вещество - это неорганические соли, которые составляют 5% от  массы тела.',
            },
            {
                title: 'Базальный метаболизм',
                msg: 'Базальный метаболизм - это  суточное потребление энергии организмом в состоянии бодрствования и покоя,  без учёта физической активности, приёма пищи, стресса или изменения внешней  температуры.',
            },
            {
                title: 'WHR (Соотношение талии к бедрам)',
                msg: 'Это соотношение объема талии к  объему бедер и является важным показателем для определения центрального  ожирения.',
            },
            {
                title: 'ИМТ (Индекс массы тела)',
                msg: 'ИМТ в  основном используется для оценки внешнего проявления ожирения, и это  общепринятый стандарт для измерения ожирения.',
            },
            {
                title: 'Процент жира в теле',
                msg: 'Процент  телесного жира - это измерение состава тела, которое показывает, какая часть  массы тела является жиром.',
            },
            {
                title: 'Уровень висцерального жира',
                msg: 'Висцеральный жир - это важный показатель для оценки скрытого  ожирения.',
            },
            {
                title: 'Внутриклеточная вода (ICW)',
                msg: 'Внутриклеточная жидкость: это жидкость, содержащаяся в клетках  организма, и является основным компонентом протоплазмы.',
            },
            {
                title: 'Внеклеточная вода (ECW)',
                msg: 'Внеклеточная жидкость: Обычно относится к внеклеточным жидкостям  организма, включая плазму и межклеточную жидкость между кровеносными сосудами  и тканевыми клетками.',
            },
            {
                title: 'Метаболический Возраст',
                msg: 'Метаболический возраст относится к работе тела и его здоровье связанных с метаболической функции.',
            },
            {
                title: 'Соотношение ECW/TBW',
                msg: 'Соотношение ECW/TBW — это доля внеклеточной воды (ECW) в общей воде организма (TBW). Это важный показатель для оценки водного баланса организма.',
            },
        ],
        // 节段
        segment: {
            fat: 'Сегментный жир',
            muscle: 'Сегментная мышца',
            right: 'Право',
            left: 'Лево',
            standard: 'Нормально',
            lowStandard: 'Ниже',
            superStandard: 'Выше',
            peel: '(тара)',
        },
    },
    // 体态
    shape: {
        title: 'Обзор оценки тела',
        titles: 'Осанка тела',
        status: 'Ваше текущее физическое состояние',
        suggest: 'Предложение',
        possibility: ', есть вероятность',
        models: {
            front: 'Спереди',
            left: 'Слева',
            right: 'Справа',
            top: 'Сзади',
            low: 'Ниже',
            high: 'Выше',
            normal: 'Нормально',
        },
        item: {
            deviate: 'Значения',
            result: 'Объяснение',
            normal: 'Нормально',
			keAbnormal: 'Возможная аномалия',
            abnormal: 'Ненормально',
            head: 'Отклонение головы вперед',
            headSlant: 'наклон головы',
            roundShoulderLeft: 'округлое плечо (левая сторона)',
            roundShoulderRight: 'округлое плечо (правая сторона)',
            highLowShoudler: 'перекос плеч',
            pelvis: 'Смещение таза вперед/Смещение таза назад',
            leftKneeCheck: 'оценка левого колена',
            rightKneeCheck: 'оценка правого колена',
            leg: 'форма ноги',
            leftLeg: 'Левая нога:',
            rightLeg: 'Правая нога:',
        },
        // 定义解读
        explain: [
            {
                title: 'Отклонение головы вперед',
                msg: 'Угол между точкой уха на левой стороне и линией, соединяющей  центр шеи и медианную линию сбоку',
            },
            {
                title: 'Наклон головы',
                msg: 'Угол между серединой передней части головы и центром шеи и  медианной линией спереди',
            },
            {
                title: 'Округлое плечо (левая сторона)',
                msg: 'Угол между линией, соединяющей самую высокую точку на левой  стороне спины, и касательной к плечу',
            },
            {
                title: 'Округлое плечо (правая сторона)',
                msg: 'Угол между линией, соединяющей самую высокую точку на правой  стороне спины, и касательной к плечу',
            },
            {
                title: 'Перекос плеч',
                msg: 'Вертикальное расстояние между точками левого и правого плеча на  спине',
            },
            {
                title: 'Смещение таза вперед/Смещение таза назад',
                msg: 'Угол между линией, соединяющей среднюю точку шеи, точку  тазобедренной кости и лодыжку на левой стороне ',
            },
            {
                title: 'Оценка левого колена',
                msg: 'Угол линии, соединяющей три точки левой боковой поверхности  бедра, коленного сустава и голеностопного сустава',
            },
            {
                title: 'Оценка правого колена',
                msg: 'Угол линии, соединяющей точки правой боковой поверхности  бедра, колена и лодыжки',
            },
            {
                title: 'Форма ноги',
                msg: 'Угол линии, соединяющей переднюю точку тазобедренной кости,  коленный сустав и точку лодыжки правой и левой ноги',
            },
            {
                title: 'Антеверсия/ретроверсия таза',
                msg: 'Угол между вертикалью и плоскостью, образованной левой и правой передними верхними подвздошными остями и лобковым симфизом.'
            },
            {
                title: 'Разновеликость нижних конечностей',
                msg: 'Разница в высоте от пола между самыми нижними точками левой и правой ягодичных складок.'
            }
        ],
        exception: [
            {
                title: 'Наклон влево',
                abnormal: '',
            },
            {
                title: 'Наклон вправо',
                abnormal: '',
            },
            {
                title: 'Левая сторона выше',
                abnormal: '',
            },
            {
                title: 'Правая сторона выше',
                abnormal: '',
            },
            {
                title: 'Наклон таза назад',
                abnormal: '',
            },
            {
                title: 'Наклон таза вперед',
                abnormal: '',
            },
            {
                title: 'Гиперэкстензия левого колена',
                abnormal: '',
            },
            {
                title: 'Деформация левого колена вперед',
                abnormal: '',
            },
            {
                title: 'Гиперэкстензия правого колена',
                abnormal: '',
            },
            {
                title: 'Деформация правого колена вперед',
                abnormal: '',
            },
            {
                title: 'Ноги в форме буквы K',
                abnormal: '',
            },
            {
                title: 'Ноги в форме буквы D',
                abnormal: '',
            },
            {
                title: 'Ноги в форме буквы X',
                abnormal: '',
            },
            {
                title: 'Ноги в форме буквы O',
                abnormal: '',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Вертикальное расстояние между ушами и гравитационной линией тела',
            },
            {
                msg: 'Угол между линией, соединяющей оба уха, и горизонтальной плоскостью',
            },
            {
                msg: 'Вертикальное расстояние между левым акромионом и гравитационной линией',
            },
            {
                msg: 'Вертикальное расстояние между правым акромионом и гравитационной линией',
            },
            {
                msg: 'Разница в линиях, соединяющих основание шеи и акромионы с обеих сторон',
            },
            {
                msg: 'Вертикальное расстояние между тазобедренным суставом и гравитационной линией тела',
            },
            {
                msg: 'Угол между голеностопным суставом, точкой на 1 см ниже левого коленного сустава и тазобедренным суставом в сагиттальной плоскости',
            },
            {
                msg: 'Угол между голеностопным суставом, точкой на 1 см ниже правого коленного сустава и тазобедренным суставом в сагиттальной плоскости',
            },
            {
                msg: 'Угол между двусторонними тазобедренными, коленными и голеностопными суставами во фронтальной плоскости',
            },
        ],
        item: {
            pelvis: 'Передний наклон таза',
        },
    },
    // 围度信息
    girth: {
        title: 'Окружности',
        present: '(Присутствуют)',
        noHistory: 'Нет данных',
        tpl: [
            {
                title: 'Обхват шеи',
                key: 'neckGirth',
            },
            {
                title: 'Верхняя часть левой руки',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Верхняя часть правой руки',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Грудь',
                key: 'bustGirth',
            },
            {
                title: 'Верхняя талия',
                key: 'waistGirth',
            },
            {
                title: 'Средняя талия',
                key: 'midWaistGirth',
            },
            {
                title: 'Обхват  бедра',
                key: 'hipGirth',
            },
            {
                title: 'Обхват  левого бедра',
                key: 'leftThighGirth',
            },
            {
                title: 'Середина левого бедра',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Минимальный  обхват левого бедра',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Обхват правого бедра',
                key: 'rightThighGirth',
            },
            {
                title: 'Середина правого бедра',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Минимальный  обхват правого бедра',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Обхват левой икры',
                key: 'leftCalfGirth',
            },
            {
                title: 'Обхват правой икры',
                key: 'rightCalfGirth',
            },
            {
                title: 'Низкая талия',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Функция  плеча',
        model: {
            val: 'Значения',
            scope: 'Maximale Aktivitätsposition',
            diff: 'Сеть',
        },
        normal: 'Оценено как нормальное.',
        normalAll: 'Нет значительных аномалий в  плечевых функциях.',
        conclusion: 'Заключение',
        analyse: 'Анализ:',
        suggest: 'Предложение:',
        cause: 'Точную причину должен установить  специалист',
    },
    reportTips: {
        title: "Вы уверены, что хотите удалить этот отчет? После удаления его будет невозможно восстановить.",
        confirm: "Удалить",
        success: "Отчет удалён",
        partial: "Отчёт удалён, синхронизация части данных завершилась неудачно; свяжитесь с администратором.",
        failed: "Не удалось удалить, попробуйте позже",
        btnMsg: 'Хорошо',
        alaryTips: 'Этот отчет был удален администратором. Перейдем к следующему  отчету!',
    },
    saveQr: {
        title: 'Отчет 3D сканера тела Visbody',
        btnMsg: 'Зажмите  изображение, чтобы сохранить его на вашем телефоне.',
        tips: 'Если вы столкнулись с тем, что не можете сохранить, то  перейдите в [Настройки] и разрешите доступ',
    },
    vanCalendar: {
        end: '结束',
        start: '开始',
        title: '日期选择',
        confirm: 'Подвердить',
        startEnd: '开始/结束',
        weekdays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthTitle: function monthTitle(year, month) {
            let monthStr = month
            if (month < 10) {
                monthStr = `0${month}`
            }
            return monthStr + '.' + year
        },
        rangePrompt: function rangePrompt(maxRange) {
            return '\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 ' + maxRange + ' \u5929'
        },
    },
    share: {
        title: 'Пожалуйста, скопируйте ссылку ниже и поделитесь ею.',
        btnMsg: 'Копировать',
    },
    loading: 'Загрузка', // 第三方组件
    "waist": {
    "title": "Окружность талии и абдоминальной области",
    "hou": "Зад",
    "qian": "Перед"
  },
  "yao_wei_1": "Поясничная область",
  "yao_bu_fen_shu": "Показатель поясничной области",
  "waist_fen": "Оценка",
  "yao_wei": "Окружность талии",
  "yao_wei_jian_ti_ji": "Межталиевый объем",
  "yao_tun_bi": "WHR",
  "lun_kuo_fen_xi": "Анализ контуров",
  "bei_bu": "Спина",
  "tunbu": "Ягодичная область",
  "bei_bu_ti_ji": "Объем спины",
  "zheng_chang_fan_wei": "Нормальный диапазон:",
  "shang_ci": "Пред. ",
  "ben_ci": "Текущ. ",
  "gupen": {
    "zheng_chang": "Нормальная",
    "qian_qin_yan_chang": "Аномальный антеверсивный наклон",
    "qian_qin_yi": "Риск антеверсивного наклона",
    "hou_qin_yi": "Риск ретроверсивного наклона",
    "hou_qin_yan_chang": "Аномальный ретроверсивный наклон",
    "zuo_chang_yan_chang": "Аномальная асимметрия (левая нога длиннее)",
    "zuo_chang_yi": "Риск асимметрии (левая нога длиннее)",
    "you_chang_yi": "Риск асимметрии (правая нога длиннее)",
    "you_chang_yan_chang": "Аномальная асимметрия (правая нога длиннее)"
  },
  "gao_yao_xian": "Высокая талия",
  "gao_yao_zhong_xian": "Средняя Линия Высокой Талии",
  "gao_yao_xia_xian": "Нижняя Линия Высокой Талии",
  "xiao_yao_shang_xian": "Верхняя Линия Низкой Талии",
  "xiao_yao_zhong_xian": "Средняя Линия Низкой Талии",
  "xiao_yao_xian": "Низкая талия",
  "qv_jian1": "Верхняя Часть Высокой Талии",
  "qv_jian2": "Нижняя Часть Высокой Талии",
  "qv_jian_zhong": "Средняя Часть Талии",
  "qv_jian3": "Верхняя Часть Низкой Талии",
  "qv_jian4": "Нижняя Часть Низкой Талии",
  "celiang.failed": "Измерение не выполнено. Наденьте облегающую одежду и сохраняйте неподвижность во время измерения",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Заметный наклон головы и легкое смещение шеи. Следите за осанкой при сидении.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Заметный наклон головы и смещение шеи. Рекомендуется контроль осанки и тренировки.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Сильный наклон головы и смещение шеи. Рекомендуется профессиональная оценка и коррекция.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Легкое смещение грудного отдела. Рекомендуется контроль осанки.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Смещение грудного отдела влияет на стабильность. Рекомендуются целевые тренировки.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Заметное смещение грудного отдела и асимметрия. Рекомендуется профессиональная коррекция.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Легкое смещение поясницы, баланс сохранен. Рекомендуется тренировка кора.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Смещение поясницы влияет на стабильность. Рекомендуются корректирующие тренировки.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Заметное смещение поясницы. Рекомендуется профессиональный план коррекции.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Гипертонус мышцы, поднимающей лопатку, ГКСМ и верхней трапеции; слабость глубоких сгибателей шеи. Рекомендуется тренировка и расслабление шеи.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Гипертонус левой ГКСМ и задней лестничной мышцы; слабость правой ГКСМ. Рекомендуется тренировка баланса и расслабление шеи.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Гипертонус правой ГКСМ; слабость левой ГКСМ и задней лестничной мышцы. Рекомендуется тренировка симметрии и расслабление шеи.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Гипертонус левой верхней трапеции; слабость средней/нижней. Рекомендуется тренировка средней/нижней трапеции и расслабление верхней.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Гипертонус внутренних ротаторов и приводящих мышц бедра; слабость средней ягодичной. Рекомендуется тренировка средней ягодичной и растяжка.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Гипертонус средней ягодичной и грушевидной; слабость приводящих, ротаторов и ЛКС. Рекомендуется тренировка ног и расслабление ягодиц.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Гипертонус средней ягодичной и грушевидной; односторонняя слабость приводящих, ротаторов и ЛКС. Рекомендуется двусторонняя тренировка баланса.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Гипертонус левых хамстрингов и подколенной мышцы; слабость квадрицепса и камбаловидной. Рекомендуется тренировка квадрицепса/камбаловидной и растяжка.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Гипертонус левого квадрицепса; слабость большой ягодичной и хамстрингов. Рекомендуется тренировка ягодиц/задней цепи и растяжка.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Гипертонус правых хамстрингов и подколенной мышцы; слабость квадрицепса и камбаловидной. Рекомендуется тренировка квадрицепса/камбаловидной и растяжка.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Гипертонус правого квадрицепса; слабость большой ягодичной и хамстрингов. Рекомендуется тренировка ягодиц/задней цепи и растяжка.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Легкое отклонение позвоночника. Следите за осанкой и тренируйте кор.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Умеренное отклонение позвоночника. Рекомендуются тренировки со специалистом.",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Гипертонус правой верхней трапеции; слабость средней/нижней. Рекомендуется тренировка средней/нижней трапеции и расслабление верхней.",
    ...ruLocale,
    ...agrEn,
  "neckReport": {
  "title": "Функции шеи",
  "conclusion": "Заключение по оценке функции шеи",
  "loading": "Отчёт формируется. Пожалуйста, подождите.",
  "failed": "Синтез не удался",
  "analysis": "Анализ",
  "suggestion": "Рекомендация",
  "suggestionText": "Обратитесь к специалисту для дальнейшего обследования и лечения."
}
}
